// extracted by mini-css-extract-plugin
export default {"badge":"error-badge_badge__rN4u3","slideIn":"error-badge_slideIn__pIX0o","icon":"error-badge_icon__s752c"};